import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-percentage-single-bar',
  standalone: false,
  templateUrl: './percentage-single-bar.component.html',
  styleUrls: ['./percentage-single-bar.component.scss']
})
export class PercentageSingleBarComponent implements OnInit {

  @Input()
  barColor: string;

  @Input()
  colorRemaning: string;

  @Input()
  label: string;

  @Input()
  percentage: number;

  percentageLabel: string;
  constructor() { }

  ngOnInit(): void {
    this.percentageLabel = (this.percentage * 100).toFixed(2);
  }

}
